var _linearGradient, _linearGradient2, _linearGradient3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuLogoSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42.416,
    height: 44.514,
    viewBox: "0 0 42.416 44.514",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0a1egub0na",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8940"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "88llz53adc",
    x1: 0,
    x2: 1,
    xlinkHref: "#0a1egub0na"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t4agi0r0gd",
    x1: 0.166,
    y1: 0.175,
    x2: 0.851,
    y2: 0.865,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff7ad"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "3mhshwprkb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 38466",
    style: {
      fill: "none"
    },
    d: "M0 0h32.229v40.786H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Launcher icon",
    transform: "translate(.766 3.43)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 40840"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 40839",
    style: {
      clipPath: "url(#3mhshwprkb)"
    },
    transform: "translate(2.89)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13890",
    d: "M30.516 21.764a4.082 4.082 0 0 0-5.621 1 9.3 9.3 0 1 1-.408-11.373 3.985 3.985 0 0 0 4.626 1.167 4.036 4.036 0 0 0 1.567-6.309A17.341 17.341 0 1 0 5.861 30.33l10.11 9.944a1.782 1.782 0 0 0 2.488.012l9.674-9.335h-.039a17.322 17.322 0 0 0 3.39-3.558 4.025 4.025 0 0 0-.967-5.628",
    style: {
      fill: "#ffe500"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13889",
    d: "M24.316-10 5.673-5.718A6.213 6.213 0 0 0 5.466 6.64L24.316 11a1.294 1.294 0 0 0 1.294-1.292V-8.706A1.294 1.294 0 0 0 24.316-10",
    transform: "translate(14.39 17.259)",
    style: {
      opacity: 0.7,
      fill: "url(#88llz53adc)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 3648",
    cx: 3.208,
    cy: 3.208,
    r: 3.208,
    transform: "translate(17.234 14.57)",
    style: {
      fill: "url(#t4agi0r0gd)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 3647",
    cx: 3.208,
    cy: 3.208,
    r: 3.208,
    transform: "translate(17.234 14.57)",
    style: {
      fill: "url(#t4agi0r0gd)"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLogoSmall);
export default __webpack_public_path__ + "viewer/static/media/menu-logo-small.f72a0630f382bf3e4cb8ff77ef49f649.svg";
export { ForwardRef as ReactComponent };